
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../common/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';
import { ArticleViewModel } from '../../models/ArticleViewModel';
import { ArticleSummaryWithCountViewModel } from '../../models/ArticleSummaryWithCountViewModel';
import { ArticleStatusEnum } from '../../enums/ArticleStatus.enum';
import { ReleaseCountViewModel } from '../../models/ReleaseCountViewModel';


@Injectable()
export class ArticleApiService {

    constructor(private httpService: HttpWrapperService ) { }

    public getArticle(articleId: number): Observable<ArticleViewModel> {
        return this.httpService.get<ArticleViewModel>('/articles', {'articleId' : articleId}).pipe(
            map(article => {
                article.articleStatus = ArticleStatusEnum[article.articleStatus.toString()];
                if (article.scheduledDate  != null) {
                    article.scheduledDate = new Date(article.scheduledDate);
                }
                return article;
            }));
    }

    public saveArticle(article: ArticleViewModel): Observable<ArticleViewModel> {
        return this.httpService.post<ArticleViewModel>('/articles', article );
    }

    public deleteArticle(articleId: number): Observable<void> {
        return this.httpService.delete<void>(`/articles?articleId=${articleId}`);
    }

    public getArticleSummaries(searchText: string): Observable<ArticleSummaryWithCountViewModel> {
        return this.httpService.get<ArticleSummaryWithCountViewModel>('/articles/summaries', { searchText : searchText });
    }

    public getReleaseCounts(): Observable<ReleaseCountViewModel[]> {
        return this.httpService.get<ReleaseCountViewModel[]>('/articles/releaseCounts');
    }

}
